import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import Pagination from "./Pagination";

class PendingApprovalsPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            documents: { data: [], total: 0 },
            pagination: { page: 1 },
            search: '',
        };
        this.searchTimer = null;
    }

    componentDidMount() {
        this.getDocuments();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.pagination.page !== this.state.pagination.page) {
            this.getDocuments();
        }
    }

    getDocuments = async () => {
        const { pagination, search } = this.state;
        const qs = new URLSearchParams();
        qs.append('page', pagination.page);
        if (search !== '') {
            qs.append('search', search);
        }

        const request = await axios.get(`/api/person_documents/pending-approvals?${qs}`);
        this.setState({ documents: request.data });
    }

    handleSearch = (e) => {
        const search = e.target.value;
        clearTimeout(this.searchTimer);
        this.setState({ search, pagination: { page: 1 } }, () => {
            this.searchTimer = setTimeout(() => this.getDocuments(), 300);
        });
    }

    updateCurrentPage = (tab, page) => {
        this.setState({ pagination: { page } });
    }

    render() {
        const { documents, pagination } = this.state;

        return (
            <>
                <div className="card card-custom gutter-b my-5">
                    <div className="card-header border-0 pt-7">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label font-weight-bolder font-size-h4 text-dark-75">Mis aprobaciones pendientes</span>
                            <span className="text-muted mt-3 font-weight-bold font-size-sm"><span className="text-primary">{documents.total}</span> documentos pendientes de revisar</span>
                        </h3>
                        <div className="card-toolbar">
                            <div className="input-icon mb-4">
                                <input
                                    onChange={this.handleSearch}
                                    name="search"
                                    type="text"
                                    className="form-control"
                                    placeholder="Buscar" />
                                <span>
                                    <i className="flaticon2-search-1 text-primary icon-md"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="card-body pt-1">
                        <div className="table-responsive">
                            <table className="table table-borderless m-0 table-valign">
                                <thead>
                                    <tr>
                                        <th colSpan={2}>Nombre del archivo</th>
                                        <th>Completador</th>
                                        <th>Nombre de expediente</th>
                                        <th>Fecha</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {documents.data?.map((document) => (
                                        <tr key={document.id}>
                                            <td>
                                                <img src={"/assets/img/" + window.getMimeSVG(document.extension)} />
                                            </td>
                                            <td>
                                                <a href={document.review_url} className="text-dark-75 font-weight-bolder font-size-lg">
                                                    {document.title}
                                                </a>
                                            </td>
                                            <td>
                                                <span className="text-muted font-weight-bold">{document.provider_name}</span>
                                            </td>
                                            <td>
                                                <span className="text-muted font-weight-bold">{document.dossier_name}</span>
                                            </td>
                                            <td>
                                                <span className="text-muted font-weight-bold">{document.date}</span>
                                            </td>
                                            <td className="text-right">
                                                <a href={document.review_url}>
                                                    <button className="btn btn-icon btn-light btn-xs">
                                                        <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                    </button>
                                                </a>
                                            </td>
                                        </tr>
                                    ))}
                                    {documents.data?.length === 0 &&
                                        <tr>
                                            <td colSpan={6} className="text-center text-muted font-weight-bold">No hay documentos pendientes por revisar</td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>

                        {documents.total > 10 &&
                            <Pagination
                                updateCurrentPage={this.updateCurrentPage}
                                currentPage={pagination.page}
                                totalFiles={documents.total}
                                split={10} />
                        }
                    </div>
                </div>
            </>
        );
    }
}

export default PendingApprovalsPanel;

if (document.getElementById('PendingApprovalsPanel')) {
    ReactDOM.render(<PendingApprovalsPanel />, document.getElementById('PendingApprovalsPanel'));
}
